import { render, staticRenderFns } from "./link-browser.vue?vue&type=template&id=2b5a24bf&"
import script from "./link-browser.vue?vue&type=script&lang=js&"
export * from "./link-browser.vue?vue&type=script&lang=js&"
import style0 from "./link-browser.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports